import PropTypes from 'prop-types';
import React from 'react';

import { LoadErrorPlaceholder } from '@/components/common/MapStateShell';

/**
 * Shown in place of a map that could not be drawn: MapStateShell's existing
 * "Map unavailable" card, a visible sentence saying so, and the map
 * document's caption as plain text, so the reader still learns what the map
 * would have shown.
 *
 * Shared on purpose (#1190): MapErrorBoundary renders it when a map throws,
 * and hub #1191 renders it when a saved map can't be loaded.
 */
export default function MapUnavailable({ title, caption, className }) {
    return (
        <div className={className || ''}>
            <LoadErrorPlaceholder displayText={title || 'Map'} />
            {/* The card says "Map unavailable" only in its aria-label, so
                this sentence is what tells a sighted reader why it's empty.
                It sits outside the card because role="img" hides children. */}
            <p className="small mt-2 mb-0">This map couldn&apos;t be shown.</p>
            {caption && <p className="text-muted small mt-1 mb-0">{caption}</p>}
        </div>
    );
}

MapUnavailable.propTypes = {
    /** The map's title; names the placeholder card */
    title: PropTypes.string,
    /** The map document's caption, shown under the card when present */
    caption: PropTypes.string,
    /** Optional CSS class name(s) applied to the wrapper element */
    className: PropTypes.string,
};
